<!-- img overlay -->
<div id="imgOverlay" fxLayoutAlign="center center" *ngIf="displayFullImg" (click)="displayFullImg=false">
    <img src="{{ fullSizeImg }}" />
</div>
<!-- menu -->
<!-- <nav [class.sticky]="sticky" #stickyMenu class="menunavbar" id="menu-nav-bar"> -->
<nav class="menunavbar" #stickyMenu [class.sticky]="sticky" id="menu-nav-bar">
    <div class="menuwrapper">
        <ng-container *ngFor="let sec of (menu$ | async).sections; index as sIdx">
            <a #sectionLink *ngIf="sec.items.length && !sec.hidden && (menuItemFilter$ | async)[sIdx].includes(true)" [ngClass]="sIdx == 0 ? 'current' : '' " attr.data-section="{{ 'sect-'+sIdx }}"
                (click)="scroll('sect-'+sIdx, $event)">
                {{ sec.name }}
            </a>
        </ng-container>
    </div>
</nav>
<div id="menu-sections-wrapper">
    <div id="no-results" *ngIf="displayNoResultsMessage">
        <h3>Brak wyników!</h3>
    </div>
<div #section *ngFor="let sec of (menu$ | async).sections; index as sIdx" id="{{ 'sect-'+sIdx }}">
    <div *ngIf="sec.items.length > 0 && !sec.hidden && (menuItemFilter$ | async)[sIdx].includes(true)" fxLayout="column" fxLayoutGap="20px" class="section">
        <h2  [style.color]="appColors.primaryColor">{{ sec.name }}</h2>
        <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="20px" fxLayoutGap.gt-xs="20px grid"
            fxLayoutAlign="stretch">
            <!-- <div *ngFor="let item of sec.items" fxFlex.lt-sm="100%" fxFlex.gt-xs="50%" ngStyle.gt-xs="margin-bottom: 20px;"> -->
            <ng-container *ngFor="let item of sec.items;index as iIdx">            
                <div *ngIf="(menuItemFilter$ | async)[sIdx][iIdx]" fxFlex.lt-lg="100%" fxFlex.gt-md="33%" ngStyle.gt-xs="margin-bottom: 20px;">
                    <!-- extra div added to correctly render a gap between wrapped row elements https://stackoverflow.com/questions/54057311/angular-flex-layout-with-row-and-column-spacing -->
                    <!-- <mat-card class="menu-item-tile" style="height: 100%; margin-bottom: 20px;"> -->
                        
                    <div class="itemCard" [ngStyle]="{ 'border-color': appColors.borderColor }" *ngIf="!item.hidden" fxLayout="row" fxLayoutGap="10px">
                        <div class="mini-photo" fxFlex="20%" *ngIf="item.imageFilename" (click)="showImg(item.imageFilename)">
                            <img src="{{ publicImageURL + restID + '/' + item.imageFilename + '_thumbnail' + menuItemImgExt }}" loading="lazy">
                        </div>
                        <!-- <mat-card-header class="m0"> -->
                        <!-- <mat-card-title>{{ item.name }}</mat-card-title> -->
                        <div>
                            <h3>{{ item.name }}<span *ngIf="item.weight" style="text-transform: lowercase;"> - {{item.weight}}</span></h3>
                            <!-- </mat-card-header> -->
                            <ul *ngIf="item.ingr" style="font-size: smaller;list-style-type: none;margin: 0px;padding: 0px 5px 15px;line-height: normal;">
                                <li *ngFor="let i of item.ingr">{{i}}</li>
                            </ul>
                            <div>
                                <p *ngIf="item.desc" class="itemDesc">{{ item.desc }}</p>
                                <p><strong>Cena: {{ item.price|currency:"PLN": "" }}</strong></p>
                            </div>
                            <!-- <div> -->
                            <div *ngIf="item.variant" fxLayout="column">
                                <div *ngFor="let variant of item.variant;index as vi" fxLayout="row"
                                    fxLayoutAlign="center center">
                                    <div fxFlex="70">{{ variant }}</div>
                                    <div class="variantQuantButtons" fxFlex="30" fxLayout="row" fxLayoutAlign="end center">
                                        <button mat-button color="accent"
                                            *ngIf="displayQuantity(item._id, {name:variant,idx:vi})">
                                            <mat-icon (click)="removeItem(item._id,{name:variant,idx:vi})">remove</mat-icon>
                                        </button>
                                        <div fxFlexAlign="center" *ngIf="displayQuantity(item._id, {name:variant,idx:vi})">
                                            {{ displayQuantity(item._id, {name:variant,idx:vi}) }}
                                        </div>
                                        <button mat-button color="accent">
                                            <mat-icon (click)="addItem(item,{name:variant,idx:vi})">add</mat-icon>
                                        </button>
                                        <mat-checkbox mat-button
                                            *ngIf="displayQuantity(item._id, {name:variant,idx:vi}) && usedByRestaurant"
                                            (change)="priorityToggle($event,item,{name:variant,idx:vi})"
                                            [checked]="checkPriority(item,{name:variant,idx:vi}) > 0">
                                            P
                                        </mat-checkbox>
                                    </div>
                                </div>
                            </div>
                            <!-- <mat-list role="list" *ngIf="item.variant">
                                    <mat-list-item *ngFor="let variant of item.variant;index as vi" class="variant">
                                        <div fxFlex="70">{{ variant }}</div>
                                        <div fxFlex="30" fxLayout="row" fxLayoutAlign="end"> -->
                            <!-- <button mat-button color="accent" *ngIf="displayQuantity(item._id, {name:variant,idx:vi})"> -->
                            <!-- <button mat-button color="accent" [ngStyle]="{'display': displayQuantity(item._id, {name:variant,idx:vi}) ?  'inline-block' : 'none'}">
                                                    <mat-icon (click)="removeItem(item._id,{name:variant,idx:vi})">remove</mat-icon>
                                            </button>
                                            <div fxFlexAlign="center" *ngIf="displayQuantity(item._id, {name:variant,idx:vi})">
                                                {{ displayQuantity(item._id, {name:variant,idx:vi}) }}
                                            </div>
                                            <button mat-button color="accent">
                                                <mat-icon (click)="addItem(item,{name:variant,idx:vi})">add</mat-icon>
                                            </button> -->
                            <!-- <button mat-flat-button color="accent" class="rem-btn">
                                                <mat-icon>remove</mat-icon>
                                            </button>
                                            <button mat-flat-button color="accent" class="add-btn">
                                                <mat-icon (click)="addItem(item,{name:variant,idx:vi})">add</mat-icon>
                                            </button> -->
                            <!-- </div>
                                    </mat-list-item>
                                </mat-list> -->
                            <!-- <div *ngIf="!item.variant"> -->
                            <!-- <div *ngIf="!item.variant" class="menu-item-btns" fxLayout="row" fxLayoutAlign="end"> -->
                            <!-- <div fxLayout="row"> -->
                            <div class="quanButtons" *ngIf="!item.variant" fxLayoutAlign="end center" fxLayout="row">

                                <button mat-button [style.color]="appColors.primaryColor" *ngIf="displayQuantity(item._id)">
                                    <mat-icon (click)="removeItem(item._id)">remove</mat-icon>
                                </button>
                                <div fxFlexAlign="center" *ngIf="displayQuantity(item._id)">
                                    {{ displayQuantity(item._id) }}
                                </div>
                                <button mat-button [style.color]="appColors.primaryColor">
                                    <mat-icon (click)="addItem(item)">add</mat-icon>
                                </button>
                                <mat-checkbox mat-button
                                            *ngIf="displayQuantity(item._id) && usedByRestaurant"
                                            (change)="priorityToggle($event,item)"
                                            [checked]="checkPriority(item) > 0">
                                            P
                                </mat-checkbox>
                            </div>
                            <!-- </div> -->

                            <!-- <button mat-flat-button color="accent" class="add-btn">
                                        <mat-icon (click)="addItem(item)">add</mat-icon>
                                    </button> -->
                            <!-- </div> -->

                            <!-- </div>           -->
                            <!-- </mat-card>         -->
                        </div>
                    </div>
                    
                </div>
            </ng-container> 
        </div>
    </div>
</div>
</div>
